/* eslint-disable react/no-unknown-property */
/* eslint-disable indent */
import React, { ReactNode, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { Row, Col, Flex, message } from 'antd';
import './WorkOrderCardUI.scss';
import Label from '@/components/Label';
import { IssueType, IssueStatus, IssueDrawerData } from '@/utils/type';
import IssueStatusIcon from '@/components/IssueStatusIcon';
import RenderBottomBtn from './RenderBottomBtn';
import {
  debounce,
  transIssueDurationTime,
  formatTimeStamp,
  getClstag,
  translatorEnum,
} from '@/utils/util';
import IssueVideo from './IssueVideo';
import { useNavigate } from 'react-router-dom';
import { sendGlobalEvent } from '@/utils/emit';
import { RootState } from '@/redux/store';
import { convertSpeedMsToKmh } from '@/utils/util';
import MediaPreview, { MediaItem } from '@/components/MediaPreview';
import AccidentOrderAddModal from '@/components/AccidentOrderAddModal';
import RepairOrderAddModal from '@/components/RepairOrderAddModal';
import { useIsTakeOverBySelf } from '@/utils/hooks';
import CreateFollowupGroup from '../CreateFollowupGroup';

// eslint-disable-next-line react/display-name
export const FieldItem = React.memo(
  ({
    label,
    value,
    show = true,
  }: {
    label: string;
    value: ReactNode;
    show?: boolean;
  }) => {
    return show ? (
      <Row className="work-order-card-field" align="middle">
        <Col className="label">{label}</Col>
        <Col className="value">{value}</Col>
      </Row>
    ) : (
      ''
    );
  }
);

const WorkOrderRecord = ({
  recordList,
}: {
  recordList: { reportTime: string; description: string }[];
}) => {
  return (
    <div className="work-order-record">
      {recordList?.map((item, index) => {
        return (
          <div className="record" key={item.reportTime + index}>
            <i className="icon"></i>
            <span className="time">{formatTimeStamp(item.reportTime)}</span>
            <span className="msg">{item.description}</span>
            {index < recordList.length - 1 && <hr className="connect" />}
          </div>
        );
      })}
    </div>
  );
};

const WorkOrderCardUI = ({
  info,
  magnifyVehicleName,
  cockpitNumber,
  isDrawerOpen,
  LC_BUTTON_R2,
  LC_BUTTON_R3,
  takeOverCockpitNumber,
  takeOverUserName,
}: {
  info: any;
  magnifyVehicleName: string;
  cockpitNumber: string;
  isDrawerOpen: boolean;
  LC_BUTTON_R2?: boolean;
  LC_BUTTON_R3?: boolean;
  takeOverCockpitNumber: any;
  takeOverUserName: any;
}) => {
  const navigator = useNavigate();
  const isTakeOverBySelf = useIsTakeOverBySelf();
  const { login, newCommon } = useSelector((state: RootState) => state);
  const takeOverBySelf =
    takeOverUserName === login?.userInfo?.userName &&
    takeOverCockpitNumber === newCommon.cockpitNumber; // 被自己接管
  const [unfold, setUnfold] = useState<boolean>(true);
  const [issueDuration, setIssueDuration] = useState<string>('-');
  const [accidentModelVisible, setAccidentModelVisible] = useState(false);
  let durationTime = new Date().getTime() - info.issueStartTime;

  const issue = useSelector((state: RootState) => state.issue);

  const goToProcessIssue = () => {
    const processIssue = issue.list?.find(
      (item: IssueDrawerData) => item.issueStatus === IssueStatus.PROCESS
    );
    if (processIssue) {
      if (isTakeOverBySelf) {
        message.error('您已在接管车辆中，请先退出接管');
        return;
      }
      navigator(`/app/singleview?vehicleName=${processIssue?.vehicleName}`);
    }
  };

  const changeUnfoldStatus = () => {
    setUnfold(!unfold);
  };

  useEffect(() => {
    let timer: any = null;
    timer = setInterval(() => {
      durationTime = durationTime + 1000;
      const t = transIssueDurationTime(durationTime);
      setIssueDuration(t);
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, [info.vehicleName, info.issueStartTime]);
  useEffect(() => {
    if (LC_BUTTON_R3 && !takeOverBySelf) {
      debounce(goToProcessIssue, 500)();
    }
  }, [LC_BUTTON_R3]);

  const renderEvent = () => {
    return (
      <Flex>
        {info.issueEventList?.map((item: any) => {
          return (
            <Label
              key={item.eventType}
              text={translatorEnum('ALARM_EVENT_ENUM', item.eventType)}
            />
          );
        })}
      </Flex>
    );
  };

  const renderVideoPic = () => {
    if (info.issueType === IssueType.OPS && unfold) {
      return (
        <IssueVideo
          vehicleName={info.vehicleName}
          magnifyVehicleName={magnifyVehicleName}
        />
      );
    } else if (info.issueType === IssueType.PROBLEM_REPORT) {
      // 转换附件数据为 MediaItem 格式
      const mediaItems: MediaItem[] =
        info.attachment?.map((url: string, index: number) => ({
          id: `${info.issueId}_${index}`,
          url: url,
          type: 'image' as const,
          thumbnail: url,
          name: `附件${index + 1}`,
        })) || [];

      return (
        <>
          <FieldItem
            label="补充照片"
            value={
              <MediaPreview
                items={mediaItems}
                maxDisplay={4}
                size="medium"
                onPreview={(item, index) => {
                  console.log('预览附件:', item, index);
                }}
              />
            }
          />
        </>
      );
    } else {
      return <></>;
    }
  };

  const goToSingle = () => {
    if (isTakeOverBySelf) {
      message.error('您已在接管车辆中，请先退出接管');
      return;
    }
    navigator(`/app/singleview?vehicleName=${info?.vehicleName}`);
    sendGlobalEvent('CLOSE_DRAWER');
  };
  return (
    <div className="work-order-card-container" key={info.vehicleName}>
      <div
        className={classNames('vehicle-name-container', {
          redbg:
            info.issueReminder || info.emergencyIssue || info.reportReminder,
        })}
      >
        <div
          clstag={getClstag(newCommon.cockpitMode, 'Card_GoSingle')}
          className="info-wrapper"
        >
          <span className="vehicle-name" onClick={goToSingle}>
            {info.vehicleName}
          </span>
          <div
            className="station-name"
            style={{
              width:
                info.reportReminder && info.issueReminder ? '80px' : '180px',
            }}
          >
            {info.stationName}
          </div>
          {info.reportReminder && <i className="report-reminder-icon"></i>}
          {info.issueReminder && <i className="hasten-icon">催促单</i>}
        </div>
        <IssueStatusIcon
          status={info.emergencyIssue ? 'urgent' : info.issueStatus}
        />
      </div>

      <div className="work-order-info-container">
        <FieldItem label="事件" value={renderEvent()} />
        {unfold &&
          info.issueType === IssueType.OPS &&
          info.issueEventRecordList?.length > 0 && (
            <WorkOrderRecord
              recordList={info?.issueEventRecordList?.slice(0, 10)}
            />
          )}
        <FieldItem label="工单持续时间" value={issueDuration} />
        <FieldItem
          show={info.issueType === IssueType.PROBLEM_REPORT}
          label="发生问题时间"
          value={info.operateIssueTime ?? '-'}
        />
        <Row>
          <Col span={12}>
            <FieldItem
              show={info.issueType === IssueType.OPS}
              label="配送状态"
              value={
                translatorEnum('SCHEDULE_STATE_ENUM', info.scheduleState) ?? '-'
              }
            />
          </Col>
          <Col span={12}>
            <FieldItem
              label="系统状态"
              show={info.issueType === IssueType.OPS}
              value={
                translatorEnum('SYSTEM_STATE_ENUM', info.systemState) ?? '-'
              }
            />
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <FieldItem
              label="车辆模式"
              show={info.issueType === IssueType.OPS}
              value={
                translatorEnum('VEHICLE_STATE_ENUM', info.vehicleState) ?? '-'
              }
            />
          </Col>
          <Col span={12}>
            <FieldItem
              label="运行速度"
              show={info.issueType === IssueType.OPS}
              value={convertSpeedMsToKmh(info?.speed, 1)}
            />
          </Col>
          <Col span={24}>
            <FieldItem
              label="补充照片"
              show={info.issueType === IssueType.OPS}
              value={
                <MediaPreview
                  items={
                    info?.manualAlarmRecordAttachmentList?.map((item: any) => ({
                      id: item.fileKey,
                      url: item.url,
                      type: item.type,
                      thumbnail: item.url,
                      name: item.fileKey,
                    })) || []
                  }
                  maxDisplay={4}
                  size="medium"
                />
              }
            />
          </Col>
        </Row>
        <FieldItem
          show={info.issueType === IssueType.PROBLEM_REPORT}
          label="问题描述"
          value={info.issueDescription ?? '-'}
        />

        {[IssueStatus.PROCESS, IssueStatus.ON_HOLD].includes(
          info.issueStatus
        ) &&
          isDrawerOpen &&
          renderVideoPic()}
      </div>
      <div className="action-buttons">
        <a
          className="accident-btn"
          onClick={() => setAccidentModelVisible(true)}
        >
          创建事故单
        </a>
        <CreateFollowupGroup issueInfo={info} />
      </div>
      <div className="bottom-btns">
        <RenderBottomBtn
          LC_BUTTON_R2={LC_BUTTON_R2}
          issueInfo={info}
          cockpitNumber={cockpitNumber}
        />
      </div>

      {info.issueType === IssueType.OPS &&
        [IssueStatus.PROCESS, IssueStatus.ON_HOLD].includes(
          info.issueStatus
        ) && (
          <div
            className="card-bottom-btn"
            onClick={changeUnfoldStatus}
            clstag={
              unfold
                ? getClstag(newCommon.cockpitMode, 'Card_Collapse')
                : getClstag(newCommon.cockpitMode, 'Card_Expand')
            }
          >
            <span>{unfold ? '收起' : '展开'}</span>
            <img
              src={
                unfold
                  ? require('@/assets/images/cockpit/fold_icon.png')
                  : require('@/assets/images/cockpit/unfold_icon.png')
              }
            />
          </div>
        )}
      {accidentModelVisible && (
        <AccidentOrderAddModal
          vehicleName={info.vehicleName}
          issueNumber={info.issueNumber}
          onCancel={() => setAccidentModelVisible(false)}
        />
      )}
    </div>
  );
};

export default React.memo(WorkOrderCardUI);
